var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"total-total mb-2"},[_vm._v("Total buildings: "+_vm._s(_vm.totalSelected))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }